import React from "react";
import { Container, Row } from "reactstrap";
import BreadCrumb from "Components/Common/BreadCrumb";
import AllPersons from "./AllPersons";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import { useLocation } from "react-router-dom";

const AgencyPersons = () => {
  const location = useLocation();
  usePageActivity(location.pathname, "Agency Persons");

  document.title = "Persons | CIMS";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Persons" pageTitle="Dashboard" />

          <AllPersons />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AgencyPersons;
